module.exports = __webpack_public_path__ + "static/media/boomerang.204f2be4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/DevicePreview/boomerang.gif
// module id = 1504
// module chunks = 0